
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSlider from './components/HeroSlider';
import WelcomeSection from './components/WelcomeSection';
import NewsSection from './components/NewsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSlider />
      <WelcomeSection />
      <NewsSection />
      <Footer />
    </div>
  );
};

export default HomePage;
